import { Loader2Icon } from '@/shared/ui/Icons';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'h-5 w-5',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

export function LoadingSpinner({ className = '', size = 'md' }: LoadingSpinnerProps) {
  return (
    <Loader2Icon
      className={`animate-spin text-slate-300 ${sizeClasses[size]} ${className}`}
    />
  );
}
